import { environment } from '../config/environment';
import type { NotificationSettings } from '../types/user';
import { useApiClient } from './api';

export const useNotificationService = () => {
    const apiClient = useApiClient();

    const getUserNotifications = async (): Promise<NotificationSettings> => {
        const response = await apiClient.get(`${environment.expressApiUrl}/api/notifications`);
        return response.data;
    };

    const updateNotifications = async (notifications: Partial<NotificationSettings>): Promise<NotificationSettings> => {
        // Only send the productUpdates setting
        const { productUpdates } = notifications;
        const settingsToUpdate = {
            productUpdates,
        };

        const response = await apiClient.put(`${environment.expressApiUrl}/api/notifications`, settingsToUpdate);
        return response.data;
    };

    return {
        getUserNotifications,
        updateNotifications,
    };
};
